module.exports = __webpack_public_path__ + "static/fonts/Gilroy-Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-gilroy/Gilroy-Light.woff2
// module id = C6i4
// module chunks = 0